import React, { FC, memo } from 'react';
import { DivLimitIndicator } from './styles';

type TProps = {
  length: number;
  maxLength: number;
  className?: string;
};

const FnLimitIndicator: FC<TProps> = ({ length, maxLength, className = '' }) => {
  return (
    <DivLimitIndicator className={className}>
      {length}/{maxLength}
    </DivLimitIndicator>
  );
};

export default memo(FnLimitIndicator);
